import axios from '../utils/axios';
import type { SsoCredentials, SsoSignInResult } from '../types/index';
import { createRequestError } from '../utils/requestErrors';

// Which stored Metrc sign-in would be used. Exactly one of: a facility (an MCA call for that facility) or purpose 'import'
// (the import screen's list of facilities, before any facility is known). Anything else is a 400 for SSO organizations.
export type SsoCredentialsRequest = {
  organizationId: number | string;
  marketId: number;
} & ({ mcaFacilityId: number; purpose?: never } | { purpose: 'import'; mcaFacilityId?: never });

export async function getSsoCredentials(payload: SsoCredentialsRequest): Promise<SsoCredentials> {
  try {
    const response = await axios.get('/sso/credentials', { params: payload });
    return response.data;
  } catch (error) {
    throw createRequestError(error);
  }
}

// Saves a completed Keycloak sign-in for the signed-in RetailId user.
export async function signInWithSso(payload: {
  organizationId: number | string;
  marketId: number;
  ssoIdToken: string;
  ssoAccessToken: string;
  ssoRefreshToken: string;
}): Promise<SsoSignInResult> {
  try {
    const response = await axios.post('/sso/signin', payload);
    return response.data;
  } catch (error) {
    throw createRequestError(error);
  }
}

// RID-3173: confidential-client markets. The API exchanges the code itself, so no token passes through the browser.
export async function signInWithSsoCode(payload: {
  organizationId: number | string;
  marketId: number;
  code: string;
  codeVerifier: string;
  redirectUri: string;
  nonce: string;
}): Promise<SsoSignInResult> {
  try {
    const response = await axios.post('/sso/signin/code', payload);
    return response.data;
  } catch (error) {
    throw createRequestError(error);
  }
}
